import { getHiddenDataString } from '../hidden-data-provider';
import { ICartData } from '../../projects/shopping-cart/cart-bridger-pay/interfaces';

/**
 * Allows to TypeScript recognize TikTok namespace
 */
declare global {
    interface Window {
        ttq: any;
        tiktokProductPagesViewContent: any;
    }
}

/**
 * add to cart
 */
export const tiktokAddToCart = (cartData: ICartData) => {

    if(!window.ttq ||
        !cartData.addedProductSKUID ||
        !cartData.cartItems) return;

    const cartItem = cartData.cartItems.find((item => item.skuid === cartData.addedProductSKUID));
    if(!cartItem) return;

    window.ttq.track('AddToCart', {
        content_id: cartItem.skuNumber,
        content_type: 'product',
        content_name: cartItem.skuName,
        content_category: cartItem.departmentName, // (product category: plugins, bundles, etc...)
        quantity: 1,
        price: cartItem.skuPrice,
        value: cartData.priceData.totalPrice,
        currency: 'USD',
    });
};

/**
 * lead
 */
export const tiktokLead = () => {
    if(!window.ttq) return;
    window.ttq.track('Subscribe');
};

/**
 * create account
 */
export const tiktokCreateAccount = () => {
    if(!window.ttq) return;
    window.ttq.track('CompleteRegistration');
};

/**
 * purchase
 */
export const tiktokPurchase = () => {
    if(!window.ttq) return;
    window.ttq.track('PlaceAnOrder');
};

export const tiktokProductPagesViewContent = () => {
    if(!window.ttq) return;

    const jsonString = getHiddenDataString('efs-data');
    let json = null;

    try{
        json = JSON.parse(jsonString);
    }
    catch(ex){}

    if(!json || !Array.isArray(json) || json.length <= 0) return;

    const product = json[0];
    if(product.skuNumber && product.skuPrice > 0){

        window.ttq.track('ViewContent', {
            content_id: product.skuNumber,
            content_type: 'product',
            content_name: product.documentName,
            content_category: product.departmentID,
            quantity: 1,
            price: product.skuPrice,
            currency: 'USD'
        });
    }
};
